import { FC, useContext, useMemo } from 'react';
import { Select, Typography } from 'antd';
import { FieldTypeContext } from '../../providers/FieldTypeContext';
import { useLayoutEditorContext } from '../../providers/editor/LayoutEditorContext';
import extractFieldsFromLayout from '../../services/editorExtractors/extractFieldsFromLayout';
import FlexCol from '../atoms/FlexCol';

/** Multi-select for choosing which sub-fields appear in the composite field preview button. */
export const PreviewFieldsPicker: FC = () => {
    const editor = useLayoutEditorContext();
    const { fieldTypes } = useContext(FieldTypeContext);

    const previewFieldIds = editor.type === 'compositeField' ? editor.previewFieldIds : [];
    const handleChange = editor.type === 'compositeField' ? editor.handlePreviewFieldIdsChange : undefined;

    const options = useMemo(() => {
        const structure = editor.layout?.structure;
        if (!structure) return [];

        return extractFieldsFromLayout(structure, fieldTypes).map(f => ({
            value: f.fieldId,
            label: f.label,
        }));
    }, [editor.layout?.structure, fieldTypes]);

    return (
        <FlexCol gap={0} stretch>
            <Typography.Text>Preview Fields</Typography.Text>
            <Select
                mode="multiple"
                variant="filled"
                placeholder="Select fields to show in preview"
                value={previewFieldIds}
                onChange={handleChange}
                options={options}
                aria-label="preview-fields-picker"
                style={{ width: 400 }}
            />
        </FlexCol>
    );
};
